import { Download as DownloadIcon } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { Breadcrumbs } from 'src/components/breadcrumbs/Breadcrumbs';
import { PATHS } from 'src/constants/paths';
import { lang } from 'src/utils';

import {
  HeaderContainer,
  HeaderTitleSection,
  HeaderTopRow,
} from '../BulkReplaceComponentPage.styled';

interface HeaderProps {
  showExportButton?: boolean;
  onExportClick?: () => void;
  isExporting?: boolean;
  hasData?: boolean;
}

export const Header = ({
  showExportButton = false,
  onExportClick,
  isExporting = false,
  hasData = false,
}: HeaderProps) => {
  return (
    <HeaderContainer>
      <Breadcrumbs
        items={[
          {
            label: lang.components,
            link: PATHS.COMPONENTS,
          },
          {
            label: lang.bulkReplace,
          },
        ]}
      />
      <HeaderTopRow>
        <HeaderTitleSection>
          <Typography variant="h3">{lang.bulkReplace}</Typography>
        </HeaderTitleSection>
        {showExportButton && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onExportClick}
            disabled={isExporting || !hasData}
            size="small">
            {lang.export}
          </Button>
        )}
      </HeaderTopRow>
    </HeaderContainer>
  );
};
